export function delay(seconds: number) {
  const secondsToMilliseconds = seconds * 1000
  return new Promise(res => setTimeout(res, secondsToMilliseconds))
}
